import {Router} from '@multipass-system';
import {EventBus} from 'esp-js';

import {LEGAL_STORE_ID, LegalEvents} from '../legal-store';
import {SESSION_STORE_ID, SessionEvents, SessionStoreModel} from '../session-store';
import {NavigationEvents, PageActivatedEvent} from './events';
import {NAVIGATION_STORE_ID} from './navigationStore';
import {Page} from './navigationStoreModel';

const DOC_PAGES: ReadonlySet<Page> = new Set<Page>(['signup']);

export class ShellRouteHandler {
    readonly #router: Router;
    readonly #eventBus: EventBus;

    constructor(router: Router, eventBus: EventBus) {
        this.#router = router;
        this.#eventBus = eventBus;
    }

    registerRoutes(): void {
        this.#router.register('/', () => this.#activatePage('landing'));
        this.#router.register('/how-it-works', () => this.#activatePage('howItWorks'));
        this.#router.register('/login', () => this.#activatePage('login'));
        this.#router.register('/signup', () => this.#activatePage('signup'));
        this.#router.register('/legal', () => this.#activatePage('legal'));
        this.#router.register('/home', () => this.#activateGuardedPage('home'));
        this.#router.register('/account', () => this.#activateGuardedPage('account'));
    }

    #activateGuardedPage(page: Page): void {
        const session = this.#eventBus.getModel<SessionStoreModel>(SESSION_STORE_ID);
        if (session.status !== 'loggedIn') {
            this.#router.navigate('/login', {replace: true});
            return;
        }
        this.#activatePage(page);
    }

    #activatePage(page: Page): void {
        this.#eventBus.publishEvent(NAVIGATION_STORE_ID, NavigationEvents.pageActivated, {page} satisfies PageActivatedEvent);
        if (DOC_PAGES.has(page)) {
            this.#eventBus.publishEvent(SESSION_STORE_ID, SessionEvents.legalDocumentsRequested, {});
        }
        if (page === 'legal') {
            this.#eventBus.publishEvent(LEGAL_STORE_ID, LegalEvents.documentsRequested, {});
        }
    }
}
